import getFormatMessage from '../../../locales/get-format-message';
import { MessageSubType, MessageType } from '../../../model/api-modules';

//  用户交互标题分类
export const getCustomUserSubject = (type: MessageSubType) => {
  switch (type) {
    case MessageSubType.PermissionUp:
    case MessageSubType.PermissionDown:
      return getFormatMessage('title_owner_transfer_notification');
    case MessageSubType.PermissionAdmin:
    case MessageSubType.PermissionUserGroupJoin:
    case MessageSubType.PermissionUserGroupRemove:
    case MessageSubType.MemberPermissionChange:
      return getFormatMessage('title_permission_change_text');
    case MessageSubType.PermissionChange:
      return getFormatMessage('title_group_permission_change');
    case MessageSubType.PermissionScopeChange:
      return getFormatMessage('title_group_scope_change');
    case MessageSubType.PermissionStudioDelete:
      return getFormatMessage('title_permission_studio_delete');
    case MessageSubType.PermissionGameDelete:
      return getFormatMessage('title_permission_game_delete');
    case MessageSubType.PermissionEnvDelete:
      return getFormatMessage('title_permission_env_delete');
    case MessageSubType.PermissionRemove:
      return getFormatMessage('title_permission_remove_text');
    case MessageSubType.VoluntarilyQuit:
      return getFormatMessage('title_exit_org');
    case MessageSubType.MemberAppJoinFor:
      return getFormatMessage('title_application_join_text');
    case MessageSubType.MemberAppJoinSuccess:
      return getFormatMessage('title_join_the_organization_successfully_text');
    case MessageSubType.MemberAppJoinReject:
      return getFormatMessage('title_application_rejection_text');
    case MessageSubType.AdminInviteMemberSuccess:
      return getFormatMessage('title_new_join_organization_successfully');
    case MessageSubType.ServiceOpenSuccess:
      return getFormatMessage('title_service_open_success');
    case MessageSubType.ServiceOpenFail:
      return getFormatMessage('title_service_open_failed');
    case MessageSubType.CompanyCertifiedSuccess:
      return getFormatMessage('title_company_certified_successfully');
    case MessageSubType.FeeCenterBalanceAlert:
      return getFormatMessage('title_balance_alert');
    case MessageSubType.ServiceSubmitOpenApplySchedule:
      return getFormatMessage('title_service_apply_pending');
    case MessageSubType.ServiceOpenSuccessSchedule:
      return getFormatMessage('title_service_apply_pass');
    case MessageSubType.ServiceOpenFailSchedule:
      return getFormatMessage('title_service_apply_fail');
    case MessageSubType.CompanyCertifiedFail:
      return getFormatMessage('title_company_certified_failed');
    case MessageSubType.Default:
      return getFormatMessage('title_permission_change_text');
  }
};

// system notice reason 系统消息原因content
export const getCustomReason = (type: MessageSubType, reason: string) => {
  switch (type) {
    case MessageSubType.PermissionUp:
      return (
        // getFormatMessage('owner_type')
        'Owner'
      ); // 权限变更
    case MessageSubType.PermissionDown:
      return (
        // getFormatMessage('admin_type')
        'Admin'
      ); // 权限变更
    case MessageSubType.PermissionUserGroupJoin:
      return getFormatMessage('action_added_type'); // 加入用户组
    case MessageSubType.PermissionUserGroupRemove:
      return getFormatMessage('action_removed_type'); // 移出用户组
    case MessageSubType.PermissionRemove: // 人员变动：被移出X工作室
      return getFormatMessage('permission_remove_text');
    case MessageSubType.VoluntarilyQuit: // 主动退出 => 退出人
      return getFormatMessage('exits_text');
    case MessageSubType.MemberAppJoinSuccess: // 人员变动，申请通过
      return getFormatMessage('join_the_organization_successfully_text');
    case MessageSubType.MemberAppJoinReject: // 人员变动，申请被拒绝
      return getFormatMessage('application_rejection_text');
    case MessageSubType.AdminInviteMemberSuccess: // 人员变动：新用户被邀请加入
      return getFormatMessage('new_join_organization_successfully');

    default:
      return reason; // 其他的就是申请加入组织的，用户自己填写原因
  }
};

// system notice subject 系统消息标题分类
export const getCustomSystemSubject = (type: MessageSubType) => {
  switch (type) {
    case MessageSubType.FunctionRevise: // 功能调整
      return getFormatMessage('changes_c');
    case MessageSubType.Hotfix: // bug修复
      return getFormatMessage('fixed_c');
    case MessageSubType.ServiceOpenSuccess: // 开通成功
      return getFormatMessage('notice_apply_success');
    case MessageSubType.ServiceOpenFail: // 开通失败
      return getFormatMessage('notice_apply_failed');
    default:
      return getFormatMessage('announcement_c');
  }
};
// system notice subject 系统消息标题分类
export const getCustomSystemTitle = (type: MessageSubType) => {
  switch (type) {
    case MessageSubType.ServiceOpenSuccess: // 开通成功
      return getFormatMessage('apply_success_message');
    case MessageSubType.ServiceOpenFail: // 开通失败
      return getFormatMessage('apply_failed_message');
    default:
      return '';
  }
};
// system notice 快捷标题 系统消息标题分类
export const getCustomSystem = (type: MessageSubType) => {
  switch (type) {
    case MessageSubType.FunctionRevise: // 功能调整
      return getFormatMessage('changes_type');
    case MessageSubType.Hotfix: // bug修复
      return getFormatMessage('fixed_type');
    case MessageSubType.ServiceOpenSuccess: // 开通成功
      return getFormatMessage('notice_type');
    case MessageSubType.ServiceOpenFail: // 开通失败
      return getFormatMessage('notice_type');
    default:
      return getFormatMessage('announcement_type');
  }
};
export const getMsgSubject = (
  messageType: MessageType,
  subType: MessageSubType,
  title?: string
) => {
  // if (messageType === MessageType.UserActive) {
  //   return 'Notice';
  // }
  // if (messageType === MessageType.System) {
  //   return getCustomSystemSubject(subType);
  // }
  if (messageType === MessageType.UserActive) {
    return getCustomUserSubject(subType);
  }
  if (messageType === MessageType.System) {
    return `${getCustomSystemSubject(subType)}${title}`;
  }
};
